import { store } from '@/store';
import ToastService from '@/modules/toasts/services/ToastService';
import WCSimpleToast from '@/modules/toasts/components/WCSimpleToast/WCSimpleToast.vue';

export default async function requireEmployeeLogin(to, from, next) {
  const isAuthenticated = store.getters['user/isEmployee'];

  // TODO: Change 'next(...)' to 'return {...}' after Vue Router 4 upgrade
  if (isAuthenticated) {
    next();
  } else {
    // Not logged in
    ToastService.open(WCSimpleToast, {
      props: {
        variant: 'warning',
        title: 'Authentication',
        message: "You'll need to login first",
      },
      timeout: 7000,
    });
    next({ name: 'EmployeeLogin', query: { redirectTo: to.fullPath } });
  }
}
